/* FondoCero · <fc-product> (packs, regalos, upsells, compra, barra fija, entrega), <fc-gallery> (carrusel, miniaturas, zoom) y <fc-countdown>. Requiere fc-cart.js. */
(() => {
  'use strict';
  const FC = (window.FC = window.FC || {});

  class FcProduct extends HTMLElement {
    connectedCallback() {
      try {
        this.config = JSON.parse(this.querySelector('[data-fc-config]').textContent);
      } catch (error) {
        console.error('[FC] Configuración no válida', error);
        return;
      }
      this.section = this.closest('.fc-main') || this;
      this.form = this.querySelector('form[data-fc-form]');
      this.variantInput = this.form && this.form.querySelector('[data-fc-variant-input]');
      this.errorEl = this.querySelector('[data-fc-error]');
      this.toastEl = this.querySelector('[data-fc-gift-toast]');
      this.index = this.config.selected;
      this.addEventListener('change', this.onChange);
      if (this.form) this.form.addEventListener('submit', this.onSubmit);
      FC.product = this;
      FC.setConfig(this.config);
      this.select(this.index, { source: 'init' });
      this.initSticky();
      this.initDelivery();
      requestAnimationFrame(() => this.classList.add('fc-ready'));
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
      if (this.blockObserver) this.blockObserver.disconnect();
      if (FC.product === this) FC.product = null;
    }

    get pack() {
      return this.config.packs.find((p) => p.index === this.index) || null;
    }

    upsellTotal() {
      return [...this.querySelectorAll('[data-fc-upsell]:checked')].reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
    }

    total() {
      const pack = this.pack;
      return (pack ? pack.price : 0) + this.upsellTotal();
    }

    select(index, { source = 'main' } = {}) {
      const pack = this.config.packs.find((p) => p.index === index);
      if (!pack) return;
      const previousUnits = this.pack ? this.pack.units : 0;
      this.index = index;
      this.querySelectorAll('[data-fc-pack]').forEach((card) => {
        const selected = Number(card.dataset.fcPack) === index;
        card.classList.toggle('is-selected', selected);
        const input = card.querySelector('.fc-pack__input');
        if (input) input.checked = selected;
      });
      if (this.variantInput) this.variantInput.value = pack.variantId;
      this.updateGifts(pack.units, source !== 'init' && pack.units > previousUnits);
      this.updateTotal();
      this.updatePriceRow(pack, source !== 'init');
      this.updateAvailability(pack);
      const stickyName = this.section.querySelector('[data-fc-sticky-name]');
      if (stickyName) stickyName.textContent = pack.short || pack.title;
      if (source !== 'init') document.dispatchEvent(new CustomEvent('fc:pack-change', { detail: { index, source, pack } }));
    }

    updateAvailability(pack) {
      const label = this.querySelector('[data-fc-atc-label]');
      document.querySelectorAll('[data-fc-atc], [data-fc-sticky-atc], [data-fc-compact-atc]').forEach((btn) => {
        btn.disabled = !pack.available;
      });
      if (label) label.textContent = pack.available ? this.config.atcLabel : 'Agotado';
    }

    updateTotal() {
      FC.animateMoney([...document.querySelectorAll('[data-fc-total]')], this.total());
    }

    updatePriceRow(pack, animate) {
      const root = this.section;
      const priceEls = [...root.querySelectorAll('[data-fc-price], [data-fc-sticky-price]')];
      if (animate) FC.animateMoney(priceEls, pack.price);
      else priceEls.forEach((el) => (el.dataset.fcValue = pack.price));
      const hasSave = pack.save > 0;
      root.querySelectorAll('[data-fc-compare], [data-fc-sticky-compare]').forEach((el) => {
        el.hidden = !hasSave;
        const target = el.querySelector('[data-fc-compare-value]') || el;
        if (hasSave) target.textContent = FC.money(pack.ref);
      });
      const badge = root.querySelector('[data-fc-save-badge]');
      if (badge) {
        badge.hidden = !hasSave;
        badge.textContent = FC.fill(badge.dataset.template || '−{pct} %', { pct: pack.pct });
      }
    }

    updateGifts(units, announce) {
      const unlockedNow = [];
      const gifts = [...this.querySelectorAll('[data-fc-gift]')];
      const count = this.querySelector('[data-fc-gift-count]');
      const on = gifts.filter((g) => units >= Number(g.dataset.minUnits)).length;
      if (count) count.textContent = FC.fill(count.dataset.template, { n: on, total: gifts.length });
      const box = this.querySelector('[data-fc-gifts]');
      if (box && gifts.length) box.style.setProperty('--fc-gp', `${Math.round((on / gifts.length) * 100)}%`);
      gifts.forEach((gift) => {
        const unlocked = units >= Number(gift.dataset.minUnits);
        const wasUnlocked = gift.classList.contains('is-unlocked');
        gift.classList.toggle('is-unlocked', unlocked);
        gift.classList.toggle('is-locked', !unlocked);
        if (!unlocked) gift.classList.remove('is-just-unlocked');
        if (unlocked && !wasUnlocked && announce) {
          unlockedNow.push(gift.dataset.name);
          gift.classList.remove('is-just-unlocked');
          void gift.offsetWidth;
          gift.classList.add('is-just-unlocked');
        }
      });
      if (!this.toastEl) return;
      if (unlockedNow.length) this.toastEl.textContent = FC.fill(this.toastEl.dataset.template, { regalo: unlockedNow.join(' + ').toLowerCase() });
      else if (announce !== undefined) this.toastEl.textContent = '';
    }

    onChange = (event) => {
      const target = event.target;
      if (target.matches('.fc-pack__input')) this.select(Number(target.value), { source: 'main' });
      else if (target.matches('[data-fc-upsell]')) this.updateTotal();
    };

    onSubmit = (event) => {
      if (!this.pack) return;
      event.preventDefault();
      this.addSelected();
    };

    async addSelected(errorEl) {
      const pack = this.pack;
      if (!pack || !pack.available) return;
      const items = [{ id: pack.variantId, quantity: 1 }];
      this.querySelectorAll('[data-fc-upsell]:checked').forEach((input) => items.push({ id: Number(input.value), quantity: 1 }));
      const buttons = document.querySelectorAll('[data-fc-atc], [data-fc-sticky-atc], [data-fc-compact-atc]');
      const errorTarget = errorEl || this.errorEl;
      buttons.forEach((b) => {
        b.classList.add('is-busy');
        b.setAttribute('aria-busy', 'true');
      });
      [this.errorEl, errorTarget].forEach((el) => {
        if (el) el.hidden = true;
      });
      try {
        const cart = await FC.cart.add(items);
        FC.cart.open(cart);
      } catch (error) {
        if (errorTarget) {
          errorTarget.textContent = error.message || 'No se ha podido añadir al carrito.';
          errorTarget.hidden = false;
        }
      } finally {
        buttons.forEach((b) => {
          b.classList.remove('is-busy');
          b.removeAttribute('aria-busy');
        });
      }
    }

    scrollToSelector() {
      const bundle = this.querySelector('[data-fc-bundle]');
      if (!bundle) return;
      bundle.scrollIntoView({ behavior: FC.reducedMotion() ? 'auto' : 'smooth', block: 'center' });
      const checked = bundle.querySelector('.fc-pack__input:checked');
      if (checked) setTimeout(() => checked.focus({ preventScroll: true }), FC.reducedMotion() ? 0 : 450);
    }

    initSticky() {
      const sticky = this.section.querySelector('[data-fc-sticky]');
      const atc = this.querySelector('[data-fc-atc]');
      if (!sticky || !atc || !('IntersectionObserver' in window)) return;
      document.documentElement.classList.toggle('fc-sticky-all', sticky.classList.contains('fc-sticky--all'));
      let pastButton = false;
      const blockers = new Set();
      const update = () => {
        const show = pastButton && blockers.size === 0;
        sticky.classList.toggle('is-visible', show);
        sticky.toggleAttribute('inert', !show);
        sticky.setAttribute('aria-hidden', String(!show));
        document.documentElement.classList.toggle('fc-has-sticky', show);
      };
      this.stickyObserver = new IntersectionObserver(([entry]) => {
        pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        update();
      });
      this.stickyObserver.observe(atc);
      this.blockObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => (entry.isIntersecting ? blockers.add(entry.target) : blockers.delete(entry.target)));
        update();
      });
      document.querySelectorAll('[data-fc-hide-sticky]').forEach((el) => this.blockObserver.observe(el));
      sticky.querySelector('[data-fc-sticky-pack]').addEventListener('click', () => this.scrollToSelector());
      sticky.querySelector('[data-fc-sticky-atc]').addEventListener('click', () => this.addSelected());
    }

    initDelivery() {
      const card = this.querySelector('[data-fc-delivery]');
      const journey = this.querySelector('[data-fc-journey]');
      const el = card || journey;
      if (!el) return;
      const min = Number(el.dataset.min);
      const max = Number(el.dataset.max);
      const cutoff = Number(el.dataset.cutoff);
      const configured = min > 0 && max >= min;
      const parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date())
        .forEach((p) => (parts[p.type] = p.value));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
      const isWeekend = (d) => d.getUTCDay() === 0 || d.getUTCDay() === 6;
      const addBusinessDays = (date, n) => {
        const d = new Date(date);
        let added = 0;
        while (added < n) {
          d.setUTCDate(d.getUTCDate() + 1);
          if (!isWeekend(d)) added += 1;
        }
        return d;
      };
      const late = Number(parts.hour) >= cutoff || isWeekend(today) ? 1 : 0;
      const from = addBusinessDays(today, min + late);
      const to = addBusinessDays(today, max + late);
      const fmt = (d, options) => new Intl.DateTimeFormat('es-ES', Object.assign({ timeZone: 'UTC' }, options)).format(d);
      const month = (d) => fmt(d, { month: 'short' }).replace('.', '');
      const label = (d) => `${fmt(d, { weekday: 'long' })}, ${d.getUTCDate()} ${month(d)}`;
      const short = (d) => `${fmt(d, { weekday: 'short' }).replace('.', '')}, ${d.getUTCDate()} ${month(d)}`;
      const range = (a, b) =>
        a.getTime() === b.getTime() ? short(b) : a.getUTCMonth() === b.getUTCMonth() ? `${a.getUTCDate()}–${b.getUTCDate()} ${month(b)}` : `${a.getUTCDate()} ${month(a)} – ${b.getUTCDate()} ${month(b)}`;
      if (journey) {
        const ship = late ? addBusinessDays(today, 1) : today;
        journey.querySelectorAll('[data-fc-when]').forEach((w) => {
          const kind = w.dataset.fcWhen;
          if (kind === 'today') w.textContent = `Hoy, ${today.getUTCDate()} ${month(today)}`;
          else if (configured && kind === 'ship') w.textContent = ship.getTime() === today.getTime() ? 'Sale hoy' : short(ship);
          else if (configured && kind === 'eta') w.textContent = range(from, to);
        });
      }
      if (!configured) return;
      const mainText = el.querySelector('[data-fc-delivery-text]');
      if (mainText)
        mainText.textContent = from.getTime() === to.getTime() ? `Recíbelo el ${label(to)}` : FC.fill(el.dataset.template, { min: label(from), max: label(to) });
      const cutEl = el.querySelector('[data-fc-cutoff-text]');
      const updateCut = () => {
        const p = {};
        new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
          .formatToParts(new Date())
          .forEach((x) => (p[x.type] = x.value));
        const weekend = p.weekday === 'Sat' || p.weekday === 'Sun';
        const left = cutoff * 60 - (Number(p.hour) * 60 + Number(p.minute));
        if (!weekend && left > 0) {
          const time = `<strong>${Math.floor(left / 60)} h ${left % 60} min</strong>`;
          cutEl.innerHTML = FC.fill(FC.esc(el.dataset.cutToday), { tiempo: time });
        } else {
          cutEl.textContent = el.dataset.cutLater;
        }
      };
      if (cutEl) {
        updateCut();
        setInterval(updateCut, 30000);
      }
      el.hidden = false;
    }
  }

  class FcGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fc-track]');
      if (!this.track) return;
      this.slides = [...this.track.children];
      this.thumbs = [...this.querySelectorAll('[data-fc-thumb]')];
      this.countEl = this.querySelector('[data-fc-count]');
      this.prevBtn = this.querySelector('[data-fc-prev]');
      this.nextBtn = this.querySelector('[data-fc-next]');
      this.index = 0;
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKeydown);
      this.addEventListener('click', this.onClick);
      this.updateArrows();
      this.initZoom();
    }

    onScroll = () => {
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => {
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i !== this.index) this.setActive(i);
      });
    };

    onKeydown = (event) => {
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.go(this.index + 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.go(this.index - 1);
      }
    };

    onClick = (event) => {
      const thumb = event.target.closest('[data-fc-thumb]');
      if (thumb) return this.go(Number(thumb.dataset.fcThumb));
      if (event.target.closest('[data-fc-prev]')) return this.go(this.index - 1);
      if (event.target.closest('[data-fc-next]')) return this.go(this.index + 1);
      const zoom = event.target.closest('[data-fc-zoom]');
      if (zoom) this.openZoom(zoom.dataset.fcZoom, zoom.querySelector('img'));
    };

    go(i) {
      const index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: this.slides[index].offsetLeft, behavior: FC.reducedMotion() ? 'auto' : 'smooth' });
      this.setActive(index);
    }

    setActive(i) {
      this.index = i;
      this.thumbs.forEach((thumb, n) => {
        if (n === i) {
          thumb.setAttribute('aria-current', 'true');
          const row = thumb.parentElement;
          row.scrollTo({ left: thumb.offsetLeft - row.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
      if (this.countEl) this.countEl.textContent = String(i + 1);
      this.slides.forEach((slide, n) => {
        if (n !== i) slide.querySelectorAll('video').forEach((v) => v.pause());
      });
      this.updateArrows();
    }

    updateArrows() {
      if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
      if (this.nextBtn) this.nextBtn.disabled = this.index >= this.slides.length - 1;
    }

    initZoom() {
      const section = this.closest('.fc-main');
      this.dialog = section && section.querySelector('[data-fc-zoom-dialog]');
      if (!this.dialog || this.dialog.dataset.fcBound) return;
      this.dialog.dataset.fcBound = 'true';
      const stage = this.dialog.querySelector('[data-fc-zoom-stage]');
      const img = this.dialog.querySelector('[data-fc-zoom-img]');
      const setOrigin = (event) => {
        const rect = stage.getBoundingClientRect();
        const x = ((event.clientX - rect.left - img.offsetLeft) / img.offsetWidth) * 100;
        const y = ((event.clientY - rect.top - img.offsetTop) / img.offsetHeight) * 100;
        img.style.transformOrigin = `${Math.max(0, Math.min(100, x))}% ${Math.max(0, Math.min(100, y))}%`;
      };
      stage.addEventListener('click', (event) => {
        if (event.target !== img) return this.dialog.close();
        setOrigin(event);
        stage.classList.toggle('is-zoomed');
      });
      stage.addEventListener('pointermove', (event) => {
        if (stage.classList.contains('is-zoomed')) setOrigin(event);
      });
      this.dialog.querySelector('[data-fc-zoom-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => stage.classList.remove('is-zoomed'));
    }

    openZoom(src, sourceImg) {
      if (!this.dialog) return;
      const img = this.dialog.querySelector('[data-fc-zoom-img]');
      img.src = src;
      img.alt = sourceImg ? sourceImg.alt : '';
      this.dialog.showModal();
    }
  }

  const madridToUtc = (y, mo, d, h, mi) => {
    const guess = Date.UTC(y, mo - 1, d, h, mi);
    const p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date(guess))
      .forEach((x) => (p[x.type] = x.value));
    const asMadrid = Date.UTC(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute));
    return guess - (asMadrid - guess);
  };

  class FcCountdown extends HTMLElement {
    connectedCallback() {
      const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{1,2}):(\d{2})/.exec((this.dataset.end || '').trim());
      this.bar = this.closest('[data-fc-topbar]');
      if (!m) return;
      const [y, mo, d, h, mi] = m.slice(1).map(Number);
      this.end = madridToUtc(y, mo, d, h, mi);
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
    tick() {
      const ms = this.end - Date.now();
      if (ms <= 0) {
        clearInterval(this.timer);
        if (this.bar) this.bar.hidden = true;
        return;
      }
      if (this.bar) this.bar.hidden = false;
      const total = Math.floor(ms / 1000);
      const days = Math.floor(total / 86400);
      const h = Math.floor((total % 86400) / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      const pad = (n) => String(n).padStart(2, '0');
      const parts = days > 0 ? [`${days}d`, pad(h), pad(m)] : [pad(h), pad(m), pad(s)];
      this.innerHTML = parts.map((p) => `<span class="fc-timer__box">${p}</span>`).join('<span class="fc-timer__sep">:</span>');
      this.setAttribute('aria-label', days > 0 ? `${days} días y ${h} horas` : `${h} horas y ${m} minutos`);
    }
  }

  if (!customElements.get('fc-countdown')) customElements.define('fc-countdown', FcCountdown);
  if (!customElements.get('fc-gallery')) customElements.define('fc-gallery', FcGallery);
  if (!customElements.get('fc-product')) customElements.define('fc-product', FcProduct);
})();
